<template>
  <transition name="fade" mode="out-in">
    <div v-if="visible" class="small-modal" @click.self="hide(false)">
        <div class="modal-container">
            <div class="card-header">
                <h4>Ändra slutleveransdatum för markerade artiklar</h4>
            </div>
            <div class="card-body bg-white">
                <div class="form-group col-sm-12">
                    <label>{{ $t('Leveransdatum') }}</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <fa :icon="['fal','calendar-alt']" />
                            </span>
                        </div>
                        <date-picker v-model="delivered_at" :config="dpConfig"/>
                    </div>
                </div>
                <p class="text-danger px-3">OBS! Slutleveransdatum kommer ändras för samtliga markerade artiklar!</p>
            </div>
            <div class="card-footer text-right">
                <button class="btn text-danger" @click="hide(false)" >Avbryt</button>
                <button class="btn btn-success" @click="saveDelivery">Spara</button>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";

export default {
    props: [
        'printableIds',
        'deliveryModal'
    ],

    data() {
        return {
            delivered_at: '',
            errors: [],
            visible: false,
            dpConfig: {
              format: 'YYYY-MM-DD',
              useCurrent: false,
              locale : 'sv',
            }
        }
    },

    watch: {
        deliveryModal (n,o) {
            if (this.deliveryModal && !this.visible) this.show()
            else if (!this.deliveryModal && this.visible) this.hide(false)
        },
    },

    methods: {
        hide(reload) {
            this.visible = false;
            this.$emit('modal', reload);
        },
        show() {
            this.visible = true;
        },
        async saveDelivery() {
            let params = {
                printable_ids:  this.printableIds,
                delivered_at:   this.delivered_at,
                status:         'done'
            }

            const { data } = await axios.post('/api/printable/delivery',params);
            this.hide(true);
        },
    },


}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/EditDeliveryModal.vue